import { render, staticRenderFns } from "./pdfdemo.vue?vue&type=template&id=5f9ffcea&scoped=true&"
import script from "./pdfdemo.vue?vue&type=script&lang=js&"
export * from "./pdfdemo.vue?vue&type=script&lang=js&"
import style0 from "./pdfdemo.vue?vue&type=style&index=0&id=5f9ffcea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9ffcea",
  null
  
)

export default component.exports